/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getU64Decoder,
  getU64Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

export type DisputeFiledEvent = {
  escrowId: bigint;
  client: Address;
  reason: string;
};

export type DisputeFiledEventArgs = {
  escrowId: number | bigint;
  client: Address;
  reason: string;
};

export function getDisputeFiledEventEncoder(): Encoder<DisputeFiledEventArgs> {
  return getStructEncoder([
    ["escrowId", getU64Encoder()],
    ["client", getAddressEncoder()],
    ["reason", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
  ]);
}

export function getDisputeFiledEventDecoder(): Decoder<DisputeFiledEvent> {
  return getStructDecoder([
    ["escrowId", getU64Decoder()],
    ["client", getAddressDecoder()],
    ["reason", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
  ]);
}

export function getDisputeFiledEventCodec(): Codec<
  DisputeFiledEventArgs,
  DisputeFiledEvent
> {
  return combineCodec(
    getDisputeFiledEventEncoder(),
    getDisputeFiledEventDecoder(),
  );
}
